import { createSelector } from 'reselect';
import CenterInitiatedRepatriationReportColumns from '../../containers/CenterInitiatedRepatriationReportColumns';
import TableDefinitions from '../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.REPORTING_CENTER_INITIATED_REPATRIATIONS.isLoading;
export const getData = TableDefinitions.REPORTING_CENTER_INITIATED_REPATRIATIONS.getDataFunction();
export const getColumns = createSelector(
  getData,
  (state) => state.global.assetType.appContext,
  CenterInitiatedRepatriationReportColumns,
);
